import { render, staticRenderFns } from "./ContainerTypeButton.vue?vue&type=template&id=19d154d6"
import script from "./ContainerTypeButton.vue?vue&type=script&lang=js"
export * from "./ContainerTypeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports